
/**
 * App configuration
 */
class APPConfig
{
    /**
     * api url endpoint
     */
    static API_URL:string = import.meta.env.VITE_API_ENDPOINT ? import.meta.env.VITE_API_ENDPOINT : 'http://localhost:8080/api';
    static MERCHANT_URL:string = import.meta.env.VITE_MERCHANT_SIGN_UP_URL ? import.meta.env.VITE_MERCHANT_SIGN_UP_URL : '/signup';
    static DELIVERY_SHARE_FEE:number = import.meta.env.VITE_DELIVERY_SHARE_FEE ? parseFloat(import.meta.env.VITE_DELIVERY_SHARE_FEE) : 2;
    static APPETIT_DELIVERY_SHARE_FEE:number = import.meta.env.VITE_APPETIT_DELIVERY_SHARE_FEE ? parseFloat(import.meta.env.VITE_APPETIT_DELIVERY_SHARE_FEE) : 2;
    static APPETIT_PICK_UP_SHARE_FEE:number = import.meta.env.VITE_APPETIT_PICK_UP_SHARE_FEE ? parseFloat(import.meta.env.VITE_APPETIT_PICK_UP_SHARE_FEE) : 1;
    static MIN_AGE_REQUIRED:number = import.meta.env.VITE_MIN_AGE_REQUIRED? parseInt(import.meta.env.VITE_MIN_AGE_REQUIRED) : 21;
    static DEFAULT_TIMEZONE:string = import.meta.env.VITE_DEFAULT_TIMEZONE ? import.meta.env.VITE_DEFAULT_TIMEZONE : 'America/New_York';
    static ALLOW_SERVICE_FEE:number = import.meta.env.VITE_ALLOW_SERVICE_FEE? parseInt(import.meta.env.VITE_ALLOW_SERVICE_FEE) : 1;
    static VOUCHERIFY_ID:string = import.meta.env.VITE_VOUCHERIFY_ID? import.meta.env.VITE_VOUCHERIFY_ID : '';
    static VOUCHERIFY_TOKEN:string = import.meta.env.VITE_VOUCHERIFY_TOKEN? import.meta.env.VITE_VOUCHERIFY_TOKEN : '';
    static VOUCHERIFY_API:string = import.meta.env.VITE_VOUCHERIFY_API? import.meta.env.VITE_VOUCHERIFY_API : '';
    static GOOGLE_ANALYTICS_ID:string = import.meta.env.VITE_GOOGLE_ANALYTICS_ID? import.meta.env.VITE_GOOGLE_ANALYTICS_ID : '';
    static BUGSNAG_APIKEY:string = import.meta.env.VITE_BUGSNAG_APIKEY? import.meta.env.VITE_BUGSNAG_APIKEY : '';
    //reCAPTCHA
    static RECAPTCHA_SITE_KEY:string = import.meta.env.VITE_RECAPTCHA_SITE_KEY ? import.meta.env.VITE_RECAPTCHA_SITE_KEY : '';
    static RECAPTCHA_SECRET_KEY:string = import.meta.env.VITE_RECAPTCHA_SECRET_KEY ? import.meta.env.VITE_RECAPTCHA_SECRET_KEY : '';
    static GOOGLE_PLAY_LINK:string = import.meta.env.VITE_GOOGLE_PLAY_LINK ? import.meta.env.VITE_GOOGLE_PLAY_LINK : '';
    static APPLE_STORE_LINK:string = import.meta.env.VITE_APPLE_STORE_LINK? import.meta.env.VITE_APPLE_STORE_LINK: '';
    static STRIPE_PK: string = import.meta.env.VITE_STRIPE_PK? import.meta.env.VITE_STRIPE_PK: "";
    static MEASUREMENT_ID: string = import.meta.env.VITE_MEASUREMENT_ID? import.meta.env.VITE_MEASUREMENT_ID: "";
    
}

export default APPConfig;